import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import "@/assets/css/base.less";
import "animate.css";
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import axios from "@/util/axios";
import moment from "moment";
import "moment/locale/zh-cn";
import "@/text/text.less";
import Viewer from 'v-viewer'
import 'viewerjs/dist/viewer.css'

// 导入懒加载组件
import LazyImage from '@/components/LazyImage.vue'
import LazyVideo from '@/components/LazyVideo.vue'
import lazyLoader, { preloader } from '@/utils/lazyLoad'

moment.locale("zh-cn");

// import 'vue-fullpage.js/dist/style.css'
// import VueFullpage from '../node_modules/vue-fullpage.js/src/index'
// Vue.use(VueFullpage)
Vue.config.productionTip = false;
import "@/assets/js/rem.js";
import {
  VueJsonp
} from "vue-jsonp";
Vue.prototype.$http = axios;

Vue.use(VueJsonp);
Vue.use(ElementUI);
Vue.use(Viewer, {
  defaultOptions: {
    zIndex: 9999
  }
})

// 注册懒加载组件
Vue.component('LazyImage', LazyImage)
Vue.component('LazyVideo', LazyVideo)

// 将懒加载器挂载到Vue原型上
Vue.prototype.$lazyLoader = lazyLoader

// 获取当前屏幕宽度
store.dispatch('updateWindowInfoaction')

// 预加载关键资源
preloader.preloadCriticalResources()

// 路由守卫
router.beforeEach((to, from, next) => {
  if (to.path) {
    // 百度统计代码，如果存在的话
    if (typeof window !== 'undefined' && window._hmt) {
      window._hmt.push(['_trackPageview', to.fullPath]);
    }
  }
  if (store.state.windowInfo.screenWidth < 1025) {
    // 跳转移动端 最大兼容ipadpro
    if (to.meta.belong == "mobile") return next();
    // 如果监测到当前的链接的pc的链接就跳转H5首页
    if (to.path.indexOf("mobile") == -1) {
      next("/mobile/index");
    }
  } else {
    // 跳转pc端
    if (to.meta.belong == "pc") return next();
    // 如果监测到当前链接的H5就跳转pc首页
    if (to.path.indexOf("mobile") > -1) {
      next("/");
    }
  }
});

// 路由切换后初始化懒加载
router.afterEach(() => {
  Vue.nextTick(() => {
    // 为新页面的懒加载元素初始化观察器
    lazyLoader.observeAll()
  })
})

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");